import { render, staticRenderFns } from "./SiteNotifications.vue?vue&type=template&id=94e74c3e&scoped=true"
import script from "./SiteNotifications.vue?vue&type=script&lang=js"
export * from "./SiteNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94e74c3e",
  null
  
)

export default component.exports